import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useModal } from '../components/useModal';
import apiService from '../services/apiService';
import './ResetPasswordPage.css';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [validToken, setValidToken] = useState(true);
  const navigate = useNavigate();
  const { showError, showSuccess, ModalComponent } = useModal();

  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setValidToken(false);
      showError('Ungültiger Link', 'Der Reset-Link ist ungültig oder fehlt.');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      showError('Fehler', 'Die Passwörter stimmen nicht überein');
      return;
    }

    if (newPassword.length < 8) {
      showError('Fehler', 'Das Passwort muss mindestens 8 Zeichen lang sein');
      return;
    }

    setLoading(true);

    try {
      await apiService.post('/auth/reset-password', {
        token,
        newPassword
      });

      showSuccess(
        'Passwort zurückgesetzt',
        'Ihr Passwort wurde erfolgreich geändert. Sie können sich jetzt anmelden.'
      );

      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error) {
      showError('Fehler', error.message || 'Passwort-Reset fehlgeschlagen');
      setLoading(false);
    }
  };

  if (!validToken) {
    return (
      <div className="reset-password-page">
        <ModalComponent />
        <div className="reset-container">
          <div className="reset-header">
            <div className="reset-icon error">❌</div>
            <h1>Ungültiger Link</h1>
            <p>Der Reset-Link ist ungültig oder abgelaufen.</p>
          </div>
          <button onClick={() => navigate('/login')} className="back-button">
            Zurück zum Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="reset-password-page">
      <ModalComponent />
      <div className="reset-container">
        <div className="reset-header">
          <div className="reset-icon">🔒</div>
          <h1>Neues Passwort festlegen</h1>
          <p>Geben Sie Ihr neues Passwort ein</p>
        </div>

        <form onSubmit={handleSubmit} className="reset-form">
          <div className="form-group">
            <label htmlFor="newPassword">Neues Passwort (mind. 8 Zeichen)</label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="••••••••"
              required
              minLength={8}
              autoFocus
              disabled={loading}
              autoComplete="new-password"
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Passwort bestätigen</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="••••••••"
              required
              minLength={8}
              disabled={loading}
              autoComplete="new-password"
            />
          </div>

          <button 
            type="submit" 
            className="reset-button"
            disabled={loading}
          >
            {loading ? '⏳ Wird gespeichert...' : '✅ Passwort speichern'}
          </button>
        </form>

        <div className="reset-footer">
          <button 
            onClick={() => navigate('/login')} 
            className="link-button"
            disabled={loading}
          >
            Zurück zum Login
          </button>
        </div>
      </div>
    </div>
  );
}
